















import Vue from 'vue'
/**
 * Upload.vue の input[type="file"] 専用コンポーネント
 *  input 単独要素しかないため、propsで動的に設定できる項目が多いと無意味になるので注意
 */
export default Vue.extend({
  name: 'UploadFile',
  props: {
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    required: {
      type: Boolean,
      default: () => false
    }
  }
})
